import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import validator from 'validator';
import { postContact } from '../../../services/CommonService';
import { toast } from 'react-toastify';
import ReCAPTCHA from 'react-google-recaptcha';
// import './Contact.css';
import '../../../assets/guestportal.css';

const Contact2 = () => {
  const [formData, setFormData] = useState({
    question: '',
    name: '',
    email: '',
    explain_question: ''
  });
  const [disabled, setDisabled] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [captchaToken, setCaptchaToken] = useState('');
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const RECAPTCHA_SITE_KEY = '6LfajNMqAAAAAKnoorhq_go5iAlhDkCaI4HXyLpo';

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
    setCaptchaVerified(!!token);
    if (errors.captchaToken) {
      setErrors(prev => ({
        ...prev,
        captchaToken: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.question) {
      newErrors.question = 'Please select a question type';
    }

    if (!formData.name) {
      newErrors.name = 'Please enter your name';
    } else if (!/^[a-zA-Z\s]+$/.test(formData.name)) {
      newErrors.name = 'Special characters are not allowed';
    }

    if (!formData.email) {
      newErrors.email = 'Please enter your email';
    } else if (!validator.isEmail(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }

    if (!formData.explain_question) {
      newErrors.explain_question = 'Please explain your question';
    }

    if (!captchaVerified) {
      newErrors.captchaToken = '⚠ Please verify the CAPTCHA';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setDisabled(true);
    try {
      await postContact({
        ...formData,
        captchaToken
      });

      // Reset form
      setFormData({
        question: '',
        name: '',
        email: '',
        explain_question: ''
      });
      setCaptchaVerified(false);
      setCaptchaToken('');
      if (window.grecaptcha) {
        window.grecaptcha.reset();
      }

      setIsSuccess(true);
      toast.success('Your message has been sent successfully!');
      setTimeout(() => setIsSuccess(false), 30000);
    } catch (err) {
      toast.error('Failed to send message. Please try again.');
    } finally {
      setDisabled(false);
    }
  };

  useEffect(() => {
    const canvas = document.getElementById('networkCanvas');
    const ctx = canvas.getContext('2d');

    const setCanvasSize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    setCanvasSize();
    window.addEventListener('resize', setCanvasSize);

    class Particle {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.vx = Math.random() * 0.5 - 0.25;
        this.vy = Math.random() * 0.5 - 0.25;
        this.size = 2;
      }

      update() {
        this.x += this.vx;
        this.y += this.vy;

        if (this.x < 0 || this.x > canvas.width) this.vx *= -1;
        if (this.y < 0 || this.y > canvas.height) this.vy *= -1;
      }

      draw() {
        ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
        ctx.fillRect(this.x, this.y, this.size, this.size);
      }
    }

    const particles = Array.from({ length: 50 }, () => new Particle());

    function animate() {
      ctx.fillStyle = 'rgba(35, 45, 126, 0.1)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      particles.forEach(particle => {
        particle.update();
        particle.draw();

        particles.forEach(otherParticle => {
          const dx = particle.x - otherParticle.x;
          const dy = particle.y - otherParticle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 100) {
            ctx.beginPath();
            ctx.strokeStyle = `rgba(255, 255, 255, ${0.2 - distance / 500})`;
            ctx.lineWidth = 0.5;
            ctx.moveTo(particle.x, particle.y);
            ctx.lineTo(otherParticle.x, otherParticle.y);
            ctx.stroke();
          }
        });
      });

      requestAnimationFrame(animate);
    }

    animate();

    return () => {
      window.removeEventListener('resize', setCanvasSize);
    };
  }, []);

  return (
    <section className="contact-section">
      <canvas id="networkCanvas" className="network-canvas"></canvas>
      <div className="container">
        <div className="contact-container row">
          <div className="contact-info col-lg-6">
            <h2>Contact Us</h2>
            <p>
              Have questions or need support? Reach out to our team. We’re here to help!
            </p>

            <div className="contact-details">
              <div className='mb-3'>
                <span className="contact-icon">✉️</span>
                <Link href="mailto:support@docusafe.ai" className="text-white text-decoration-none">support@docusafe.ai</Link>
              </div>
              <div>
                <span className="contact-icon">📞</span>
                <Link href="tel:+15673421477" className="text-white text-decoration-none">+1-567-342-1477</Link>
              </div>
              <div className="contact-location">
                <div><span className="contact-icon">📍</span></div>
                <div className='contact-location-text'>
                  <p><strong>REDFOX VENTURES PTE. LTD.</strong></p>
                  <p>200 Jalan Sultan, #11-01,<br />Textile Centre, Singapore 199018</p>
                </div>
              </div>
            </div>

            <div className="contact-socials">
              <Link to="https://x.com/docusafeai" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className='text-de'>
                <svg width="28" height="28" fill="none" viewBox="0 0 28 28"><circle cx="14" cy="14" r="14" fill="#fff" opacity="0.12" /><path d="M21 10.5a5.5 5.5 0 01-1.57.43A2.75 2.75 0 0020.44 9a5.5 5.5 0 01-1.74.66A2.75 2.75 0 0014 12.25c0 .22.03.44.07.65A7.8 7.8 0 018 9.5s-3 6 3.5 8.5c-1.2.5-2.5.5-3.5.5a7.8 7.8 0 004.5 1.5c5.5 0 8.5-4.5 8.5-8.5 0-.13 0-.25-.01-.37A6.1 6.1 0 0021 10.5z" fill="#fff" /></svg>
              </Link>
              <Link to="https://www.facebook.com/docusafeAI/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg width="28" height="28" fill="none" viewBox="0 0 28 28"><circle cx="14" cy="14" r="14" fill="#fff" opacity="0.12" /><path d="M16.5 14H15v6h-3v-6h-1.5v-2.5H12V10.5c0-1.1.9-2 2-2h2v2.5h-2v1h2.5l-.5 2.5z" fill="#fff" /></svg>
              </Link>
              <Link to="https://www.linkedin.com/company/docusafeai/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg width="28" height="28" fill="none" viewBox="0 0 28 28"><circle cx="14" cy="14" r="14" fill="#fff" opacity="0.12" /><path d="M10.5 12.5h2.5v1.5h.03c.34-.64 1.18-1.32 2.43-1.32 2.6 0 3.08 1.71 3.08 3.94V20h-3v-3.5c0-.84-.02-1.92-1.17-1.92-1.17 0-1.35.91-1.35 1.85V20h-3v-7.5zM8 9.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm1.5 2c-.83 0-1.5.67-1.5 1.5V20h3v-7.5c0-.83-.67-1.5-1.5-1.5z" fill="#fff" /></svg>
              </Link>
              <Link to="https://www.instagram.com/docusafeai" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg width="28" height="28" fill="none" viewBox="0 0 28 28"><circle cx="14" cy="14" r="14" fill="#fff" opacity="0.12" /><path d="M14 9.5c2.2 0 2.5 0 3.3.1.8 0 1.4.2 1.9.4.5.2.9.5 1.3.9.4.4.7.8.9 1.3.2.5.4 1.1.4 1.9.1.8.1 1.1.1 3.3s0 2.5-.1 3.3c0 .8-.2 1.4-.4 1.9-.2.5-.5.9-.9 1.3-.4.4-.8.7-1.3.9-.5.2-1.1.4-1.9.4-.8.1-1.1.1-3.3.1s-2.5 0-3.3-.1c-.8 0-1.4-.2-1.9-.4-.5-.2-.9-.5-1.3-.9-.4-.4-.7-.8-.9-1.3-.2-.5-.4-1.1-.4-1.9-.1-.8-.1-1.1-.1-3.3s0-2.5.1-3.3c0-.8.2-1.4.4-1.9.2-.5.5-.9.9-1.3.4-.4.8-.7 1.3-.9.5-.2 1.1-.4 1.9-.4.8-.1 1.1-.1 3.3-.1zm0-1.5c-2.2 0-2.5 0-3.4.1-.9 0-1.5.2-2 .4-.6.2-1 .5-1.5 1s-.8.9-1 1.5c-.2.5-.4 1.1-.4 2-.1.9-.1 1.2-.1 3.4s0 2.5.1 3.4c0 .9.2 1.5.4 2 .2.6.5 1 1 1.5s.9.8 1.5 1c.5.2 1.1.4 2 .4.9.1 1.2.1 3.4.1s2.5 0 3.4-.1c.9 0 1.5-.2 2-.4.6-.2 1-.5 1.5-1s.8-.9 1-1.5c.2-.5.4-1.1.4-2 .1-.9.1-1.2.1-3.4s0-2.5-.1-3.4c0-.9-.2-1.5-.4-2-.2-.6-.5-1-1-1.5s-.9-.8-1.5-1c-.5-.2-1.1-.4-2-.4-.9-.1-1.2-.1-3.4-.1z" fill="#fff" /><path d="M14 11.5c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6.5c-1.4 0-2.5-1.1-2.5-2.5S12.6 13 14 13s2.5 1.1 2.5 2.5S15.4 18 14 18z" fill="#fff" /></svg>
              </Link>
            </div>
          </div>

          <form className="contact-form col-lg-6" onSubmit={handleSubmit}>
            <h3>Let's get in touch</h3>

            <div className="mb-3">
              <label className="form-label">This question is about</label>
              <select
                className={`form-select ${errors.question ? 'is-invalid' : ''}`}
                name="question"
                value={formData.question}
                onChange={handleInputChange}
              >
                <option value="">Choose Option</option>
                <option value="Sales">Sales</option>
                <option value="Technical Support">Technical Support</option>
                {/* <option value="Partnership">Partnership</option>
                <option value="Other">Other</option> */}
              </select>
              {errors.question && <div className="text-danger">{errors.question}</div>}
            </div>

            <div className="mb-3">
              <label className="form-label">Your Name</label>
              <input
                type="text"
                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                placeholder="Enter your name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
              />
              {errors.name && <div className="text-danger">{errors.name}</div>}
            </div>

            <div className="mb-3">
              <label className="form-label">Your Email</label>
              <input
                type="email"
                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                placeholder="Enter your email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
              {errors.email && <div className="text-danger">{errors.email}</div>}
            </div>

            <div className="mb-3">
              <label className="form-label">Explain your question in detail</label>
              <textarea
                className={`form-control ${errors.explain_question ? 'is-invalid' : ''}`}
                rows="4"
                placeholder="Write your question here"
                name="explain_question"
                value={formData.explain_question}
                onChange={handleInputChange}
              />
              {errors.explain_question && <div className="text-danger">{errors.explain_question}</div>}
            </div>

            <div className="mb-3">
              <ReCAPTCHA
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={handleCaptchaChange}
              />
              {errors.captchaToken && <div className="text-danger mt-1">{errors.captchaToken}</div>}
            </div>

            <button
              type="submit"
              className="btn btn-send-message w-100"
              disabled={disabled || !captchaVerified}
            >
              {disabled ? (
                <>
                  Sending... <i className="fa fa-spinner fa-spin" />
                </>
              ) : (
                "Send Message"
              )}
            </button>

            {isSuccess && (
              <div className="alert alert-success mt-4">
                <h4 className="alert-heading">Thank you!</h4>
                <p className="mb-0">Your message has been sent. We'll get back to you soon!</p>
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact2;